import React from 'react';
import styled from 'styled-components';
import { Fade } from "react-awesome-reveal";
import os1 from '../Images/os1.jpg';
import os2 from '../Images/os2.jpg';
import os3 from '../Images/os3.jpg';
import os4 from '../Images/os4.jpg';

import { useNavigate } from 'react-router-dom';

// --- Styled Components ---

const GallerySection = styled.section`
  padding: 10px 20px;
  max-width: 1200px;
  margin: 0 auto;
  font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;
`;

const GalleryTitle = styled.h2`
  text-align: center;
  font-size: 2rem;
  font-weight: 700;
  text-transform: uppercase;
  color: #439E6D;
//   margin-bottom: 5px;
`;

const P = styled.p`
//   margin-bottom: 25px;
  text-align: center;
  font-size: 1.1rem;
  color: #333333;
`;

const StyledList = styled.ul`
  list-style-type: none;
  padding-left: 0;
  max-width: 800px;
  margin: 0 auto 10px auto;
`;

const StyledListItem = styled.li`
  font-size: 1.1rem;
  color: #4a5568;
//   margin-bottom: 12px;
  position: relative;
  padding-left: 24px;
  line-height: 1.5;

  &::before {
    content: "•";
    color: #439E6D; /* Matches your theme color */
    font-weight: bold;
    font-size: 1.3rem;
    position: absolute;
    left: 4px;
    top: -2px;
  }
`;

const Grid = styled.div`
  display: grid;
  gap: 20px;
  margin-bottom: 10px;

  /* Desktop: 3 columns */
  grid-template-columns: repeat(3, 1fr);

  /* Tablet/Mobile: 2 columns */
  @media (max-width: 992px) {
    grid-template-columns: repeat(2, 1fr);
  }

  /* Small Mobile: 1 column */
  @media (max-width: 480px) {
    grid-template-columns: 1fr;
  }
`;

const ImageCard = styled.div`
  position: relative;
  height: 250px;
  overflow: hidden;
  border-radius: 4px;
  border: 4px solid #439E6D;
  background-color: #eee;
`;

const StyledImage = styled.img`
  width: 100%;
  height: 100%;
  object-fit: cover;
  transition: transform 0.5s ease;

  ${ImageCard}:hover & {
    transform: scale(1.1);
  }
`;

const HireButton = styled.button`
  background-color: #439E6D;
  color: #ffffff;
  border: none;
  padding: 12px 24px;
  font-size: 0.9rem;
  font-weight: 500;
  border-radius: 4px;
  cursor: pointer;
  transition: all 0.2s ease-in-out;
  display: block;
  margin: 0 auto;

  &:hover {
    background-color: #367e56;
  }
`;

// --- Mock Data ---

const projects = [
  { id: 1, title: "", img: os1 },
  { id: 2, title: "", img: os2 },
  { id: 3, title: "", img: os3 },
  { id: 4, title: "", img: os4 },
];

// --- Component ---

const OnshoreSurveyPage = () => {
  const navigate = useNavigate();
  
  return (
    <GallerySection>
      <Fade triggerOnce direction="up" duration={800}>
        <GalleryTitle>ONSHORE SURVEY</GalleryTitle>
        <P>We have a dedicated team for land surveys and the range services include:</P>
        
        {/* Completed list precisely matching the uploaded list image */}
        <StyledList>
          <StyledListItem>Location sites and routes surveys</StyledListItem>
          <StyledListItem>Topographical mapping</StyledListItem>
          <StyledListItem>Cadastral survey and mapping of land parcels boundaries as required by clients</StyledListItem>
          <StyledListItem>As-built surveys of existing sites/facilities for update and planning.</StyledListItem>
          <StyledListItem>Geodetic Survey for Control establishment and extension by GPS.</StyledListItem>
          <StyledListItem>Pollution surveys for remediation exercises and settlement of the associated claims</StyledListItem>
          <StyledListItem>Onshore Geotechnics.</StyledListItem>
          <StyledListItem>Structural dynamic monitoring/Subsidence surveys</StyledListItem>
          <StyledListItem>Hydrographic surveys within the inland waterways</StyledListItem>
        </StyledList>
      </Fade>

      <Grid>
        <Fade cascade damping={0.15} triggerOnce direction="up">
          {projects.map((project) => (
            <ImageCard key={project.id}>
              <StyledImage src={project.img} alt={project.title} />
            </ImageCard>
          ))}
        </Fade>
      </Grid>

      <HireButton onClick={() => navigate('/contactus')}>Hire Us</HireButton>
    </GallerySection>
  );
};

export default OnshoreSurveyPage;